import React from 'react';

import { Route, Routes } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

import ForumHeader from './components/header/ForumHeader';
import AddThreadPage from './pages/AddThreadPage';

import LoginPage from './pages/Authentication/LoginPage';
import RegisterPage from './pages/Authentication/RegisterPage';
import HomePage from './pages/HomePage';
import ThreadDetailPage from './pages/ThreadDetailPage';
import PageNotFound from './pages/PageNotFound';
import Loading from './components/common/Loading';

import { SettingProvider } from './contexts/settingContext';
import {
  URL_THREAD_DETAIL, URL_ADD_THREAD, URL_HOME, URL_LEADERBOARD,
} from './utils/common/constant';
import { asyncPreloadProcess } from './middleware/isPreload/action';
import { asyncUnsetAuthUser } from './middleware/authUser/action';
import Leaderboardage from './pages/LeaderboardPage';

const ForumApp = () => {
  const {
    authUser = null,
    isPreload = false,
  } = useSelector((states) => states);

  const dispatch = useDispatch();

  const [settingContext, setSettingContext] = React.useState({
    locale: localStorage.getItem('locale') || 'id',
    toggleLocale,
    theme: localStorage.getItem('theme') || 'light',
    toggleTheme,
  });

  React.useEffect(() => {
    dispatch(asyncPreloadProcess());
  }, [dispatch]);

  React.useEffect(() => {
    document.documentElement.setAttribute('data-theme', settingContext.theme);
  }, [settingContext.theme]);

  function toggleLocale() {
    setSettingContext((prevState) => {
      const newLocale = prevState.locale === 'id' ? 'en' : 'id';
      localStorage.setItem('locale', newLocale);
      return { ...prevState, locale: newLocale };
    });
  }

  function toggleTheme() {
    setSettingContext((prevState) => {
      const newTheme = prevState.theme === 'light' ? 'dark' : 'light';
      localStorage.setItem('theme', newTheme);
      return { ...prevState, theme: newTheme };
    });
  }

  const onLogout = () => {
    dispatch(asyncUnsetAuthUser());
  };

  if (isPreload) {
    return null;
  }

  return (
    authUser === null
      ? (
        <SettingProvider value={settingContext}>
          <Loading />
          <div className="app-container">
            <ForumHeader />
            <main>
              <Routes>
                <Route path="/*" element={<LoginPage />} />
                <Route path="/register" element={<RegisterPage />} />
              </Routes>
            </main>
          </div>
        </SettingProvider>
      )
      : (
        <SettingProvider value={settingContext}>
          <Loading />
          <div className="app-container">
            <ForumHeader logout={onLogout} name={authUser.name} logged />
            <main>
              <Routes>
                <Route path={URL_HOME} element={<HomePage />} />
                <Route path={URL_ADD_THREAD} element={<AddThreadPage />} />
                <Route path={URL_LEADERBOARD} element={<Leaderboardage />} />
                <Route path={`${URL_THREAD_DETAIL}/:threadId`} element={<ThreadDetailPage />} />
                <Route path="*" element={<PageNotFound />} />
              </Routes>
            </main>
          </div>
        </SettingProvider>
      )
  );
};

export default ForumApp;
